var styles = {
  "Button": "_Button_pb42n_1"
};

export { styles as default };
